/**
 * Updates session cache
 * @param {string} id - The session number
 * @param {string} key - The data key
 * @param {string} value - The data value
 * @returns {void}
 */
export function updateSession(id, key, value) {
  const CACHE_ROOT = 'TD_CACHE'
  const cache = localStorage.getItem(CACHE_ROOT)
  let data = /** @type {TdSessionCacheData} */ ({})

  if (cache) {
    data = JSON.parse(cache)
  }

  const sessionKey = `TdSession@${id}`

  if (!data[sessionKey]) {
    data[sessionKey] = {}
  }

  data[sessionKey][key] = value

  localStorage.setItem(CACHE_ROOT, JSON.stringify(data))
}
